var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticClass:"sync-point",attrs:{"data-automation-id":"xer-sync-point"}},[_vm._v(_vm._s(_vm.value))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }